import { Link } from 'react-router-dom';
import SiteLayout from './SiteLayout';
import { IconArrow } from './icons';

const GOALS = [
  { tag: 'objetivo 01', t: 'Do estágio ao sênior', d: 'Um caminho guiado e contínuo. Você evolui de nível com clareza — sem pular etapa e sem se perder.' },
  { tag: 'objetivo 02', t: 'Pensamento de Engenheiro', d: 'Desenvolver o Mindset P.E: entender o porquê, resolver problemas e ter autonomia pra decidir.' },
  { tag: 'objetivo 03', t: 'Sem burocracia', d: 'Descomplicar o aprendizado. Direto ao ponto, prático e no seu ritmo — do jeito que devia ser.' },
];

export default function Objetivo() {
  return (
    <SiteLayout>
      <section className="cc-phero">
        <div className="cc-hero-orb o1" />
        <div className="cc-wrap cc-hero-copy">
          <span className="cc-eyebrow">nosso objetivo</span>
          <h1 className="cc-h1">Formar engenheiros, do estágio ao <span className="cc-serif">sênior</span>.</h1>
          <p className="cc-hero-sub">
            Nosso objetivo é claro: pegar quem está começando em tecnologia e guiar até o nível sênior,
            desenvolvendo o Pensamento de Engenheiro na prática — de forma simples e sem burocracia.
          </p>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          <div className="cc-prose cc-reveal" style={{ maxWidth: '54ch' }}>
            <p style={{ fontSize: 'clamp(20px, 2.6vw, 27px)', lineHeight: 1.45, color: 'var(--cc-text)' }}>
              “Que ninguém saia daqui só sabendo <span className="cc-hl">usar ferramenta</span>.
              Que saiam sabendo <span className="cc-hl">pensar como engenheiro</span>.”
            </p>
          </div>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          <div className="cc-reveal">
            <span className="cc-eyebrow">no que a gente mira</span>
            <h2 className="cc-h2" style={{ marginBottom: 36 }}>Três metas que guiam cada aula</h2>
          </div>
          <div className="cc-values">
            {GOALS.map((g) => (
              <div className="cc-value cc-reveal" key={g.t}>
                <span className="cc-vtag">{g.tag}</span>
                <h3>{g.t}</h3>
                <p>{g.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          <div className="cc-prose cc-reveal">
            <p>Pra isso, cada trilha vai da base à aplicação real: você começa entendendo o fundamento,
            passa por labs, constrói projetos e termina resolvendo problemas como um engenheiro resolve —
            com autonomia.</p>
            <p>É prático e sem enrolação. Se no fim do módulo você não conseguiu fazer sozinho, a gente
            não cumpriu o objetivo.</p>
          </div>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          <div className="cc-cta cc-reveal">
            <h2>Pronto pra evoluir de verdade?</h2>
            <p>Comece grátis e sinta a diferença de aprender pensando como engenheiro desde o primeiro módulo.</p>
            <div className="cc-cta-actions">
              <Link className="cc-btn cc-btn-primary" to="/treinamentos/cadastro">Começar agora <IconArrow /></Link>
              <Link className="cc-btn cc-btn-ghost" to="/treinamentos">Entrar na plataforma</Link>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
